export default __webpack_public_path__ + "static/media/edit_pics-icon.b5f76e05.svg";